import { jsxs as o } from "../../_virtual/jsx-runtime.mjs";
import { w as r } from "../../packages/utils/dist/useIntersectionObserver-1ee6520e.mjs";
import "react";
import "../../packages/basic/dist/es/components/ReoIcon/ReoIcon.mjs";
import e from "../../packages/basic/dist/es/components/ReoBalloon/ReoBalloon.mjs";
import "../../packages/basic/dist/es/components/ReoButton/index.mjs";
import "../../packages/basic/dist/es/components/ReoCheckbox/index.mjs";
import "../../packages/basic/dist/es/components/ReoLink/ReoLink.mjs";
import "../../packages/basic/dist/es/_virtual/jsx-runtime.mjs";
import "../../packages/basic/dist/es/depend/classnames/index.mjs";
import "../../packages/basic/dist/es/assets/css/globalTheme.mjs";
import "../../packages/basic/dist/es/assets/css/themes/template/templateMap.mjs";
import "../../packages/basic/dist/es/components/ReoTabs/ReoTabTree.mjs";
import "../../packages/basic/dist/es/components/ReoInput/index.mjs";
import "../../packages/basic/dist/es/components/ReoSelect/ReoSelect.mjs";
import "../../packages/basic/dist/es/components/ReoPopup/ReoPopup.mjs";
import "../../packages/basic/dist/es/components/ReoUpload/UploadList.mjs";
import "../../packages/basic/dist/es/components/ReoUpload/const.mjs";
import "../../packages/basic/dist/es/depend/rc-upload/es/Upload.mjs";
import "../../packages/basic/dist/es/components/ReoUpload/DraggedUploadList.mjs";
import "../../packages/basic/dist/es/components/ReoAccordion/AccordionItem.mjs";
import "../../packages/basic/dist/es/depend/swiper/swiper-react.mjs";
import "../../packages/basic/dist/es/Basic/LoadingBar/LoadingBar.mjs";
import "../../packages/basic/dist/es/components/ReoMessage/ReoMessage.mjs";
import "../../packages/basic/dist/es/components/ReoForm/index.mjs";
import { note as i } from "./css/InputNote.css.mjs";
import l from "../../depend/classnames/index.mjs";
import { useOmitProps as n } from "../../hook/useOmitProps.mjs";
const s = (t) => {
  const m = n(
    t,
    ["className", "style", "balloonClassName", "balloonStyle", "noteContent", "noteText"]
  );
  return /* @__PURE__ */ o(
    "div",
    {
      className: t.className,
      style: t.style,
      children: [
        t.text,
        /* @__PURE__ */ o(
          e,
          {
            ...m,
            className: l(t.balloonClassName, i),
            style: t.balloonStyle,
            content: t.noteContent,
            children: [
              "*",
              t.noteText
            ]
          }
        )
      ]
    }
  );
}, E = r(s, {});
export {
  E as default
};
//# sourceMappingURL=InputNote.mjs.map
